import React from 'react';
import './AboutPage.css';
import Carousel from '../components/Carousel';
import {
  BuildingStorefrontIcon,
  MapPinIcon,
  ChartBarIcon,
  EyeIcon,
  LightBulbIcon,
  SparklesIcon
} from '@heroicons/react/24/solid';

const InfoCard = ({ icon: Icon, title, description }) => (
  <div className="info-card">
    <Icon className="info-icon" />
    <div>
      <h3 className="info-title">{title}</h3>
      <p className="info-description">{description}</p>
    </div>
  </div>
);

const Card = ({ icon: Icon, title, description, color }) => (
  <div className={`circle-card ${color}`}>
    <Icon className="icon" />
    <h3>{title}</h3>
    {Array.isArray(description) ? (
      <ul className="card-list">
        {description.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    ) : (
      <p>{description}</p>
    )}
  </div>
);

const Hexagon = ({ text, color }) => (
  <div className={`hexagon ${color}`}>
    <span className="hex-text">{text}</span>
  </div>
);

function AboutPage() {
  return (
    <div className="page page-about">
      {/* Hero Section */}
      <section className="about-hero" style={{background:"url('/images/water-about.png'),center/cover no-repeat"}}>
  <div className="about-hero-overlay"></div>
  <div className="container">
    <div className="about-hero-content">
      <h1 className="about-title">Crystal Drops</h1>
      <h2 className="about-tagline">Sustainable Water Solutions for a Better Tomorrow</h2>
      <p className="about-lead">
      Pure Innovation. Trusted Solutions. Sustainable Water for Every Need.
    </p>
      <div className="about-hero-cta">
        <a href="/services" className="btn primary">Explore Our Solutions</a>
        <a href="/contact" className="btn secondary">Get in Touch</a>
      </div>
    </div>
  </div>
</section>

{/*Description Section */}

<section className="about-description">
  <div className="about-desc-container">
    <h2 className="about-section-title">Who We Are</h2>
    <div className="about-description-content">
      <p>
        Crystal Drops is a pioneering water technology company dedicated to delivering
        sustainable treatment solutions. Since 2016, we have combined innovation,
        engineering expertise, and customer-first values to provide clean and safe
        water across residential, commercial, and industrial applications.
      </p>
      <p>
        Our focus is on creating systems that not only meet immediate needs but also
        contribute to long-term environmental balance. With branches in Bangalore and
        Hyderabad, we continue to expand our reach while staying true to our mission
        of protecting people and the planet.
      </p>
    </div>
  </div>
</section>

      {/* Intro Section */}
      <section className="about-intro">
        <div className="container">
          <h2 className="section-title">Crystal Drops Overview</h2>
          <div className="info-grid">
            <InfoCard
              icon={BuildingStorefrontIcon}
              title="Business Model"
              description="Total Water Treatment Solution Provider"
            />
            <InfoCard
              icon={MapPinIcon}
              title="Branches"
              description="Bangalore and Hyderabad"
            />
            <InfoCard
              icon={ChartBarIcon}
              title="Expertise"
              description="25+ years of experience in water technology"
            />
          </div>
        </div>
      </section>

      {/* Mission Vision Values */}
     <section className="section-mission-vision-values">
          <div className="section-header">
            <h2>OUR MISSION</h2>
        <div className="color-bars">
          <span className="bar red"></span>
          <span className="bar blue"></span>
          <span className="bar orange"></span>
        </div>
      </div>
      <div className="circle-layout">
        <Card
          icon={LightBulbIcon}
          title="MISSION"
          description="We strive to offer the best quality product and service to our customers."
          color="red"
        />
        <Card
          icon={EyeIcon}
          title="VISION"
          description=" To be India's most trusted, service oriented brand in providing Total Water treatment solution."
          color="blue"
        />
        <Card
          icon={SparklesIcon}
          title="VALUES"
          description={[
            "Customer First",
            "Commitment",
            "Sustainability",
            "Innovation and Quality"
          ]}
          color="orange"
        />
      </div>
      </section>

{/* Client List */}
      <section className="clients">
      <h2 className="clients-heading">Trusted By Leading Brands</h2>
      <div className="clients-logos">
        <Carousel />
      </div>
    </section>

      {/* Hexagon Section */}
      <section className="we-stand-for">
        <h2 className="heading">We Stand For</h2>
        <div className="hex-container">
          <Hexagon text="Customer Satisfaction" color="blue" />
          <Hexagon text="Quality" color="gray" />
          <Hexagon text="Service" color="darkblue" />
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
  <div className="about-cta-container">
    <h3 className="about-cta-title">Ready to discuss your project?</h3>
    <p className="about-cta-text">
      Let’s collaborate to design sustainable water solutions tailored to your needs.
    </p>
    <a className="about-cta-btn-primary" href="/contact">Get in Touch</a>
  </div>
</section>

    </div>
  );
}

export default AboutPage;